import { render, staticRenderFns } from "./SynonymListSearchEmpty.vue?vue&type=template&id=5fbec857&scoped=true&"
import script from "./SynonymListSearchEmpty.vue?vue&type=script&lang=js&"
export * from "./SynonymListSearchEmpty.vue?vue&type=script&lang=js&"
import style0 from "./SynonymListSearchEmpty.vue?vue&type=style&index=0&id=5fbec857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbec857",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fbec857')) {
      api.createRecord('5fbec857', component.options)
    } else {
      api.reload('5fbec857', component.options)
    }
    module.hot.accept("./SynonymListSearchEmpty.vue?vue&type=template&id=5fbec857&scoped=true&", function () {
      api.rerender('5fbec857', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SynonymList/components/common/SynonymListSearchEmpty.vue"
export default component.exports